import React, { useState } from "react";
import Row from "./RowInstaller";
import TableList from "../../components/Table";
import { useTranslation } from "react-i18next";

const List = ({ items = [], onSwitchAction = () => {} }) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState("");
  const filterItems = (items) =>
    items.filter((item) => {
      const email = item.email
        ? item.email.toLowerCase().includes(searchValue.toLowerCase())
        : undefined;
      const name =
        item.first_name && item.last_name
          ? `${item.first_name} ${item.last_name}`
              .toLowerCase()
              .includes(searchValue.toLowerCase())
          : undefined;
      const username = item.username
        ? item.username.toLowerCase().includes(searchValue.toLowerCase())
        : undefined;
      const country = item.profile.country
        ? item.profile.country.toLowerCase().includes(searchValue.toLowerCase())
        : undefined;
      const city = item.profile.city
        ? item.profile.city.toLowerCase().includes(searchValue.toLowerCase())
        : undefined;
      const cellular_number = item.profile.cellular_number
        ? item.profile.cellular_number
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        : undefined;
      return email || name || username || country || city || cellular_number;
    });

  const headCells = [
    {
      id: "first_name",
      label: t("heads_list_installers.name"),
      sortable: true,
    },
    {
      id: "email",
      label: t("heads_list_installers.email"),
      sortable: true,
    },
    {
      id: "username",
      label: t("heads_list_installers.username"),
      sortable: true,
    },
    {
      id: "country",
      label: t("heads_list_installers.country"),
      sortable: false,
    },
    {
      id: "city",
      label: t("heads_list_installers.city"),
      sortable: false,
    },
    {
      id: "cellular_number",
      label: t("heads_list_installers.mobile"),
      sortable: false,
    },
    {
      id: "connect",
      label: t("heads_list_installers.actions"),
      sortable: false,
    },
  ];
  return (
    <TableList
      headCells={headCells}
      order="asc"
      orderBy="name"
      items={filterItems(items)}
      page={0}
      rowsPerPage={5}
      setSearchValue={setSearchValue}
      add={false}
    >
      {(item) => (
        <Row
          headCells={headCells}
          onSwitchAction={onSwitchAction}
          key={item.id}
          item={item}
        />
      )}
    </TableList>
  );
};

export default List;
